import { IndexedMap } from '@vista-digital/utilities';
import superjson from 'superjson';
/**
 * Register custom classes for superjson serialization.
 */
export function registerSerializableClasses() {
    superjson.registerClass(IndexedMap);
}
//# sourceMappingURL=register-serializable-classes.js.map